import Vue from 'vue';
import * as firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/remote-config';

const firebaseApp = firebase.initializeApp({
  apiKey: 'AIzaSyAcwL4XrBEtcM9xVspdUCLWsozR2Y63YNs',
  authDomain: 'networkvivense.firebaseapp.com',
  databaseURL: 'https://networkvivense.firebaseio.com',
  projectId: 'networkvivense',
  storageBucket: 'networkvivense.appspot.com',
  messagingSenderId: '389276326727',
  appId: '1:389276326727:web:7f1c720e904303cd7b4a62',
});

const db = firebaseApp.firestore();
const remoteConfig = firebaseApp.remoteConfig();

remoteConfig.settings = {
  minimumFetchIntervalMillis:
    process.env.VUE_APP_FIREBASE_REMOTE_CONFIG_INTERVAL_MS,
};

remoteConfig.defaultConfig = {
  maintenanceModeActive: false,
  maintenanceModeContent: null,
  maintenanceModeOnlyProduction: false,
};

remoteConfig.ensureInitialized().catch(e => e);

Vue.prototype.$db = db;
Vue.prototype.$remoteConfig = remoteConfig;

export default db;
